import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { usePublicTransportService } from "../../../hooks";
import { PublicTransportDownloadSummary } from "../../../types/LayerAdmin/PublicTransportDownloadSummary";
import { getPublicTransportImportTypeLabel } from "../../../constant/PublicTransportImportType";
import { getPublicTransportDownloadStatusLabel } from "../../../constant/PublicTransportDownloadStatus";
import { Alert } from "react-bootstrap";
import { DownloadSourcesTable } from "./DownloadSourcesTable";

export const DownloadInfo = () => {

    // Get the id from the router :downloadId
    const { downloadId } = useParams<{ downloadId: string }>();
    const publicTransportService = usePublicTransportService();
    const [downloadSummary, setDownloadSummary] = useState<PublicTransportDownloadSummary | null>(null);
    const [downloadSources, setDownloadSources] = useState<any[]>([]);
    const [loadingSummary, setLoadingSummary] = useState(false);
    const [loadingSources, setLoadingSources] = useState(false);
    const [refreshSummaryToggle, setRefreshSummaryToggle] = useState(false);

    useEffect(() => {
        // Check the download id is a number
        if (downloadId === undefined || isNaN(parseInt(downloadId))) {
            return;
        }

        setLoadingSources(true);
        publicTransportService.GetPublicTansportDownloadSources(parseInt(downloadId)).then((data) => {
            setDownloadSources(data);
        }).catch((error) => {

        }).finally(() => {
            setLoadingSources(false);
        });
    }, [downloadId]);

    useEffect(() => {
        // Check the download id is a number
        if (downloadId === undefined || isNaN(parseInt(downloadId))) {
            return;
        }

        setLoadingSummary(true);

        publicTransportService.GetPublicTransportDownloadSummary(parseInt(downloadId)).then((data) => {
            setDownloadSummary(data);
        }).catch((error) => {

        }).finally(() => {
            setLoadingSummary(false);
        });


    }, [downloadId, refreshSummaryToggle]);

    const downloadTypeLabel = useMemo(() => {
        if (!downloadSummary) {
            return "";
        }
        return getPublicTransportImportTypeLabel(downloadSummary.importType);
    }, [downloadSummary]);

    const downloadStatusLabel = useMemo(() => {
        if (!downloadSummary) {
            return "";
        }
        return getPublicTransportDownloadStatusLabel(downloadSummary.status);
    }, [downloadSummary]);

    if (!downloadSummary) {
        return <h2>Download not found</h2>
    }

    return <>
        <h3>{downloadTypeLabel} download started on {downloadSummary?.downloadDate.toFormat('yyyy-MM-dd HH:mm')}<br />Status: <b><i className="text-warning">{downloadStatusLabel}</i></b></h3>
        <Alert className="p-2" variant="light">
            <p className="mb-1">Summary of sources for this download:</p>
            <ul className="list-inline d-flex gap-3 mb-0">
                <li className="text-success">{downloadSummary.successOrPatchedSources} successful / patched</li>
                <li className="">{downloadSummary.ignoredSources} ignored</li>
                <li className="text-danger">{downloadSummary.failedSources} failed</li>
            </ul>
        </Alert>
        {!loadingSources && downloadId && <DownloadSourcesTable sources={downloadSources} refreshSources={() => setRefreshSummaryToggle(!refreshSummaryToggle)} downloadId={+downloadId} />}
    </>
}